import get from "lodash/get";
import { createSelector } from "reselect";

export const baseECQSSelector = (state) => get(state, "ecqs", {});

export const getECQSWizardContextSelector = createSelector(
  baseECQSSelector,
  (ecqs) => get(ecqs, "context", []),
);
